module.exports = __webpack_public_path__ + "img/brand_logo_black.1cf50840.png";